import Vue from 'vue'
import App from './App.vue'
import store from './store'
// import './config/gtm.js'
// import './config/yandex.js'

import VueTheMask from 'vue-the-mask'
import VeeValidate from 'vee-validate';

import $ from 'jquery'
window.$ = window.jQuery = require('jquery');
window.axios = require('axios');
var VueScrollTo = require('vue-scrollto');

// config's for svgIcon 
import './plugins/svgIcon.js'
import '@/assets/icons'
// js libs
import 'bootstrap/dist/js/bootstrap.min.js'
// import 'selectric/public/jquery.selectric.min.js'
// css libs
import 'swiper/dist/css/swiper.css'
// import 'selectric/public/themes/plus/selectric.css'

window.body = $('body');

const configVeeValidate = {
  aria: true,
  classNames: {},
  classes: false,
  delay: 0,
  errorBagName: 'errors', // change if property conflicts
  events: 'input|blur',
  fieldsBagName: 'fields',
  i18n: null, // the vue-i18n plugin instance
  i18nRootKey: 'validations', // the nested key under which the validation messages will be located
  inject: true,
  locale: 'ru',
  validity: false
};

const configScrollTo = {
  container: "body",
  duration: 1200,
  easing: "ease-in-out",
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
};

Vue.use(VeeValidate, configVeeValidate);
Vue.use(VueScrollTo, configScrollTo);
Vue.use(VueTheMask);

new Vue({
  render: h => h(App),
  store,
  mounted: () => document.dispatchEvent(new Event("x-app-rendered"))
}).$mount('#app')
